import type { TNotificationProvider } from '../../utils/types';
import { useEffect, useRef, useState } from 'react';

const DURATION = 10000;
const RADIUS = 9;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const NotificationProvider = ({ notification, handleClose }: TNotificationProvider) => {
  const [paused, setPaused] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const startRef = useRef<number>(Date.now());
  const remainingRef = useRef<number>(DURATION);

  const handleClick = () => {
    handleClose(notification);
  };

  useEffect(() => {
    startRef.current = Date.now();
    timerRef.current = setTimeout(() => handleClose(notification), remainingRef.current);

    return () => {
      clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  const handleMouseEnter = () => {
    clearTimeout(timerRef.current);
    remainingRef.current -= Date.now() - startRef.current;
    setPaused(true);
  };

  const handleMouseLeave = () => {
    startRef.current = Date.now();
    timerRef.current = setTimeout(() => handleClose(notification), remainingRef.current);
    setPaused(false);
  };

  return (
    <div
      className={`notificationItem ${notification.type}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className='close' onClick={handleClick}>
        <svg width='28' height='28' viewBox='0 0 24 24' className={paused ? 'ring ring--paused' : 'ring'}>
          <circle cx='12' cy='12' r={RADIUS} className='ring-track' fill='none' strokeWidth='2' />
          <circle
            cx='12'
            cy='12'
            r={RADIUS}
            className='ring-progress'
            fill='none'
            strokeWidth='2'
            strokeLinecap='round'
            strokeDasharray={CIRCUMFERENCE}
            style={{ animationDuration: `${DURATION}ms` }}
          />
        </svg>
        <span className='close-icon'>&times;</span>
      </div>
      <span className='title'>{notification.title}</span>
      <span>{notification.text}</span>
    </div>
  );
};

export default NotificationProvider;